/**
 * Turn an axios error into a user-facing message.
 * The API returns { statusCode, message, error }, where `message` may be an
 * array of strings for 400 validation errors.
 */
export const getApiErrorMessage = (err, fallback = "Something went wrong") => {
  const msg = err?.response?.data?.message;
  if (Array.isArray(msg)) return msg.join(", ");
  return msg || err?.message || fallback;
};

export const getApiErrorStatus = (err) => err?.response?.status;
